import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useData<T>(path: string, initial: T, enabled = true) {
  const [data, setData] = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    if (!enabled) { setLoading(false); setError(""); return; }
    setLoading(true);
    setError("");
    try { setData(await api<T>(path)); } catch (cause) { setError(cause instanceof Error ? cause.message : "加载失败"); }
    finally { setLoading(false); }
  }, [enabled, path]);
  useEffect(() => { void reload(); }, [reload]);
  return { data, setData, loading, error, reload };
}
